/**
 * @description 导航设置
 * @author libaiqi
 * @date 2019/1/2
 */

import Logic from '../logic-base'

const navigationSettingBiz = new Logic()

navigationSettingBiz.addSite = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.navigationSetting.addSite,
    data: data
  })
}

navigationSettingBiz.deleteSite = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.navigationSetting.deleteSite,
    data: data
  })
}

navigationSettingBiz.getSite = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.navigationSetting.getSite,
    data: data
  })
}

navigationSettingBiz.updateSite = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.navigationSetting.updateSite,
    data: data
  })
}

export default navigationSettingBiz
